export const GRETA_FEEDBACK_COMMENT_MAX_LENGTH = 500

export const GRETA_FEEDBACK_COMMENT_MAX_ROWS = 6

export const GRETA_FEEDBACK_COMMENT_MIN_ROWS = 3

export const GRETA_FEEDBACK_REASONS = [
  { id: 'wrong', textKey: 'Greta.FeedbackReasonIncorrectKey' },
  { id: 'missing_data', textKey: 'Greta.FeedbackReasonMissingDataKey' },
  { id: 'too_slow', textKey: 'Greta.FeedbackReasonSlowKey' },
  { id: 'not_what_asked', textKey: 'Greta.FeedbackReasonNotAskedKey' },
]

export const QA_NAME_GRETA_AI_CHAT_FEEDBACK_CANCEL = 'gretaAIChatFeedbackCancel'

export const QA_NAME_GRETA_AI_CHAT_FEEDBACK_COMMENT =
  'gretaAIChatFeedbackComment'

export const QA_NAME_GRETA_AI_CHAT_FEEDBACK_FORM = 'gretaAIChatFeedbackForm'

export const QA_NAME_GRETA_AI_CHAT_FEEDBACK_REASON = 'gretaAIChatFeedbackReason'

export const QA_NAME_GRETA_AI_CHAT_FEEDBACK_SUBMIT = 'gretaAIChatFeedbackSubmit'
